export default __webpack_public_path__ + "static/media/DiseasePrediction.d1b4d062.png";